const termsRoutes = [
  // OLD START 사용여부 불분명 START
  {
    path: "/terms/service",
    name: "TermsService",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/old/TermsService.vue")
  },
  {
    path: "/terms/personal",
    name: "TermsPersonal",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/old/TermsPersonal.vue")
  },
  {
    path: "/terms/personalThirdParty",
    name: "TermsPersonalThirdParty",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/old/TermsPersonalThirdParty.vue")
  },
  {
    path: "/terms/financialAlerts",
    name: "TermsFinancialAlerts",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/old/TermsFinancialAlerts.vue")
  },
  {
    path: "/terms/personalPolicy",
    name: "TermsPersonalPolicy",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/old/TermsPersonalPolicy.vue")
  },
  // OLD START 사용여부 불분명 END
  // 2021-12 이용내역고지용 페이지 START
  {
    path: "/terms_s/sg",
    name: "NoticeOfUsageSGSK",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/all/NoticeOfUsageSG.vue")
  },
  {
    path: "/terms_k/sg",
    name: "NoticeOfUsageSGKT",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/all/NoticeOfUsageSG.vue")
  },
  {
    path: "/terms_l/sg",
    name: "NoticeOfUsageSGLG",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/all/NoticeOfUsageSG.vue")
  },
  {
    path: "/terms_s/sb",
    name: "NoticeOfUsageSBSK",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/all/NoticeOfUsageSB.vue")
  },
  // 2021-12 이용내역고지용 페이지 END
  // 2021-12 SKT 세이프가드 약관 페이지 START
  {
    path: "/terms/sg/join/:termType",
    alias: "/terms/sg/:termType",
    name: "TermsSKT",
    component: () => import(/* webpackChunkName: "terms" */ "@/views/terms/skt/SafeGaurdTermsSKT.vue")
  }
  // 2021-12 SKT 세이프가드 약관 페이지 END
];
export default termsRoutes;
